import { RootState } from '../store';

export const selectBankingState = (state: RootState) => state.banking;
export const selectBankingPendingCount = (state: RootState) => state.banking.pendingCount;
export const selectBankingInFlightCount = (state: RootState) => state.banking.inFlightCount;
export const selectBankingExtractedCount = (state: RootState) => state.banking.extractedCount;
export const selectBankingShowTab = (state: RootState) => state.banking.showBankingTab;
/** True only when the banner has been dismissed for the supplied orgId.
 *  Per-org so a dismissal on company A does not hide the banner on company B. */
export const selectBankingBannerDismissedForOrg = (state: RootState, orgId: string | undefined) =>
    !!orgId && state.banking.bannerDismissedForOrgId === orgId;
export const selectBankingLoading = (state: RootState) => state.banking.loading;
export const selectBankingTriggering = (state: RootState) => state.banking.triggering;
export const selectBankingCurrentOrgId = (state: RootState) => state.banking.currentOrgId;
